import * as React from "react"

function IconDesign(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={29} height={29} viewBox="0 0 29 29" {...props}>
      <title>{"Design"}</title>
      <g
        transform="translate(1 1.25)"
        stroke="#FFF"
        fill="none"
        fillRule="evenodd"
      >
        <circle cx={13} cy={13} r={13} />
        <path d="M7 11.658L12.254 17 27.5 1.5" />
      </g>
    </svg>
  )
}

export default IconDesign
